import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { createUseStyles } from 'react-jss';
import { Box } from '@wds/box';
import { Typography } from '@wds/typography';
const useStyles = createUseStyles(theme => {
  const border = `1px solid ${theme.palette.border.main}`;
  return {
    separator: {
      borderRight: border,
      height: `${theme.spacing[6]}px`,
      marginLeft: `${theme.spacing[3]}px`,
      marginRight: `${theme.spacing[3]}px`,
      marginTop: 'auto',
      marginBottom: 'auto'
    }
  };
});
const Badges = ({
  text,
  includeSeparator = false,
  children
}) => {
  const classes = useStyles();
  return _jsxs(_Fragment, {
    children: [_jsx(Box, {
      mr: 2,
      display: "flex",
      alignItems: "center",
      children: _jsx(Typography, {
        component: "span",
        variant: "bodySm",
        color: "darkMuted",
        children: text
      })
    }), children, includeSeparator && _jsx("div", {
      "data-testid": "Badges__OECSeparator",
      role: "presentation",
      className: classes.separator
    })]
  });
};
export default Badges;